<template>
  <div class="tag">
    <div class="d-flex justify-content-between">
      <div class="tag-boxes">
        <div class="d-flex" style="position: absolute; bottom:0;">
          <div v-for="(item ,index) in tagArray" :key="index" @click="doTag(index)" :class="{'tag-active':currentTag === index}" class="tag-body mx-1">{{item}}</div>
        </div>
      </div>
      <div class="d-flex">
        <div class="m-auto type-selecter" v-if="$route.name === 'VR_record'">
          <!-- <font-awesome-icon class="form_icon" :icon="['fas', 'search']" />
          <input type="text" name="search" class="form_input" placeholder="Search"> -->
          <button  v-if="userRole==='Teacher'" @click="downloadExcel" class="btn btn-success">{{$t('export_file')}}</button>
          <select :disabled="previous" v-model="sceneId" @change="updatedScene($event)" class="scene-select">
            <option v-for="item in sceneList" :value="item.id" :key="item.id">{{item.name}}</option>
          </select>
          <!-- <select v-model="filter" class="scene-select">
          　<option value="time">依時間排序</option>
          　<option value="account">依帳號排序</option>
          </select> -->
        </div>
        <button v-if="$route.name === 'VR_student'" type="button" @click="btnFunction" class="btn btn-primary m-auto">{{$t('generate_serial')}}</button>
        <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../assets/image/icon/close_lesson.png" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../store/api'
export default {

  name: 'label-tag',
  props: {
    tagArray: {
      type: Array,
      default: () => {
        return null
      }
    },
    previous: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data () {
    return {
      currentTag: 0,
      sceneList: [],
      sceneId: 0,
      filter: 'time',
      locale: window.localStorage.getItem('locale')
    }
  },
  computed: {
    userRole () {
      return this.$store.state.auth.userRole
    },
    mode () {
      switch (this.currentTag) {
        case 0:
          return null
        case 1:
          return 'Plot'
        case 2:
          return 'Vocab'
        case 3:
          return 'Dialog'
      }
    },
    fileName () {
      switch (this.currentTag) {
        case 0:
          return this.locale === 'tw' ? '總表紀錄' : 'General record'
        case 1:
          return this.locale === 'tw' ? '劇情模式紀錄' : 'Story record'
        case 2:
          return this.locale === 'tw' ? '單字模式紀錄' : 'Vocabulary Record'
        case 3:
          return this.locale === 'tw' ? '對話模式紀錄' : 'Conversation Record'
      }
    }
  },
  mounted () {
    this.getSceneList()
  },
  methods: {
    doTag (mode) {
      this.currentTag = mode
      this.$emit('updatedMode', parseInt(mode))
    },
    previousPage () {
      console.log(this.previous)
      if (this.previous) {
        this.$emit('previousPage')
      } else {
        this.$router.go(-1)
      }
    },
    btnFunction () {
      this.$emit('createCode')
    },
    async getSceneList () {
      const { data } = await api.get(`/VR/Scene`)
      this.sceneList = data.data
      this.sceneId = data.data[0].id
      this.updatedScene()
    },
    updatedScene () {
      this.$emit('updatedScene', this.sceneId)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      if (this.locale === 'tw') {
        require.ensure([], () => {
          const { export_json_to_excel } = require('../../../vendor/export2Excel')
          if (this.currentTag === 0) {
            const tHeader = [ '帳號', '姓名', '使用次數', '(劇情模式)使用時間', '(單字模式)使用時間', '(對話模式)使用時間', '使用總時間' ]
            const filterVal = [ 'userName', 'realName', 'usedCount', 'plotSpendTime', 'vocabSpendTime', 'dialogSpendTime', 'spendTime' ]
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, this.fileName)
          } else if (this.currentTag === 2) {
            const tHeader = [ '帳號', '姓名', '最新更新時間', '情境', '結果', '找到數量', '學習時間' ]
            const filterVal = [ 'userName', 'realName', 'createTime', 'situationName', 'isSuccess', 'foundNum', 'spendTime' ]
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, this.fileName)
          } else {
            const tHeader = [ '帳號', '姓名', '最新更新時間', '情境', '分數', '學習時間' ]
            const filterVal = [ 'userName', 'realName', 'createTime', 'situationName', 'voiceScore', 'spendTime' ]
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, this.fileName)
          }
        })
      } else {
        require.ensure([], () => {
          const { export_json_to_excel } = require('../../../vendor/Export2Excel')
          if (this.currentTag === 0) {
            const tHeader = [ 'Student ID', 'Name', 'Time(s) used', '(Story)Usage time', '(Vocabulary)Usage time', '(Conversation)Usage time', 'Total usage time' ]
            const filterVal = [ 'userName', 'realName', 'usedCount', 'plotSpendTime', 'vocabSpendTime', 'dialogSpendTime', 'spendTime' ]
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, this.fileName)
          } else if (this.currentTag === 2) {
            const tHeader = [ 'Student ID', 'Name', 'Last updated time', 'Scene', 'Result', 'Words found', 'Study time' ]
            const filterVal = [ 'userName', 'realName', 'createTime', 'situationName', 'isSuccess', 'foundNum', 'spendTime' ]
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, this.fileName)
          } else {
            const tHeader = [ 'Student ID', 'Name', 'Last updated time', 'Scene', 'Score', 'Study time' ]
            const filterVal = [ 'userName', 'realName', 'createTime', 'situationName', 'voiceScore', 'spendTime' ]
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, this.fileName)
          }
        })
      }
    },
    async downloadExcel () {
      const groupId = this.$route.params.id
      if (this.currentTag === 0) {
        let params = {
          sceneId: this.sceneId,
          pageIndex: 1,
          pageSize: 10000
        }
        const { data } = await api.get(`/VR/Record/Group/${groupId}/Students/Summary`, {params})
        this.export2Excel(data.data)
      } else {
        let params = {
          mode: this.mode,
          sceneId: this.sceneId,
          pageIndex: 1,
          pageSize: 10000
        }
        const { data } = await api.get(`/VR/Record/Group/${groupId}/Students`, {params})
        console.log(data)
        this.export2Excel(data.data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .tag {
    text-align: left;
    border-bottom: #bbbbbb solid 2px;
    .tag-boxes {
      margin-left: 60px;
      position: relative;
    }
  }
  .tag-body {
    white-space:nowrap;
		cursor: pointer;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    border-top: 2px #c7c7c7 solid;
    border-right: 2px #c7c7c7 solid;
    border-left: 2px #c7c7c7 solid;
    color: #000000;
		&:hover {
      background-color: #c7c7c7;
    }
	}
  .tag-active {
    border-radius: 10px 10px 0 0;
    background-color: #c7c7c7;
  }
  .back-icon {
    margin-right: 40px;
    margin-left: 40px;
    cursor: pointer;
  }
  .scene-select {
    margin: auto 5px !important;
  }
  @media only screen and (max-width: 768px) {
    .type-selecter {
      position: absolute;
      left: 20%;
    }
  }
  .form_input {
    height: 1.5rem;
    // width: 150px;
    // width: 30%;
  }
</style>


// WEBPACK FOOTER //
// Label.vue?206932b2